/**
 * @author Herobiam Heita
 * @email hherobiam@gmail.com
 * @create date 2023-01-10 12:10:23
 * @modify date 2023-01-10 12:10:23
 * @desc [description]
 */

export enum ItemsActionTypes {
    GET_ALL_ITEMS = "get-all-items",
    GET_SELECTED_ITEM = "get-selected-item",
    CREATE_ITEM = "create-item",
    CREATE_ITEM_ERROR= "create-item-error",
    ITEM_SUCCESS = "item-success",
    UPDATE_ITEM = "update-item",
}


